<script setup lang="ts">
type Props = {
  /** Accessible description of the glyph shown inside the chip. */
  label?: string;
};

defineProps<Props>();
</script>

<template>
  <span
    class="flex h-[1.5rem] min-w-[1.5rem] items-center justify-center gap-sm whitespace-nowrap rounded-[0.375rem] bg-surface-container p-xs px-sm drop-shadow-[0_1.5px_0.75px_rgba(0,0,0,0.25)]"
    :title="label"
  >
    <slot />
  </span>
</template>
